<template>
  <div>
    <section v-if="this.$store.state.login.loginUsuario.token || rotasNaoAutenticadas()">
        <div :class="(this.$store.state.login.loginUsuario.token ? 'wrapper' : 'wrapper menu-rota-nao-autenticada')">
            <va-navibar v-if="this.$store.state.login.loginUsuario.token"></va-navibar>
            <va-slider :slideMenuItems="slideMenuItems"></va-slider>
            <va-content-wrap></va-content-wrap>
        </div>
        <div>
          <redirecionar-usuario-apos-login />
        </div>
    </section>

    <section v-else-if="this.$route.path == '/autenticar'">
        <login-ssp/>
    </section>

    <section v-else>
        <Login />
    </section>

    <section>
        <Modals />
    </section>

  </div>
</template>

<script>
import VANaviBar from './NaviBar.vue'
import VASlider from './Slider.vue'
import VAContentWrap from 'ContentWrap.vue'
import Modals from './components/modal/Index.vue'
import store from './vuex/store.js'
import slideMenuItems from './lib/slideMenuItems.js'
import Login from './components/loginLogout/Login.vue'
import FormularioNotificacaoSemLogin from './components/notificacao/form/FormExibirNotificacaoSemLogin.vue'
import redirecionarUsuarioAposLogin from './components/loginLogout/redirecionar/Index.vue'
import LoginTokenTemporario from './components/loginLogout/LoginTokenTemporario.vue'

export default {
  name: 'app',
  data () {
    return {
      slideMenuItems: slideMenuItems,
      env: process.env.ROOT_API,
      rotasLiberadas: ['FormNotificacaoEmail']
    }
  },
  created () {
  },
  components: {
    'va-navibar': VANaviBar,
    'va-slider': VASlider,
    'va-content-wrap': VAContentWrap,
    'formulario-notificacao-sem-login': FormularioNotificacaoSemLogin,
    'login-ssp': LoginTokenTemporario,
    Modals,
    Login,
    'redirecionar-usuario-apos-login': redirecionarUsuarioAposLogin
  },
  methods: {
    rotasNaoAutenticadas () {
      let resposta = this.rotasLiberadas.filter(item => {
        return item === this.$route.name || item === this.$route.path
      })
      return resposta.length > 0 ? 1 : 0
    }
  },
  store
}
</script>

<style>
.menu-rota-nao-autenticada .sidebar-menu {
  display: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?45734647